import React, { Component } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { Card, Icon } from "antd";
import MessageBoxContent from "../MessageBoxContent";
import ChatDescription from "../ChatDescription";
import { ReactComponent as CloseSvg } from "../../assets/icon/ic_close_24dp.svg";
import { ReactComponent as MoreSvg } from "../../assets/icon/ic_more_horiz_24dp.svg";
import "./MessageBox.scss";

import { changeChat, updateChat } from "../../store/actions/chats";

import ChatService from "../../services/chat";

function ChatOptionsBox({
  chat,
  setOptionBoxRef,
  onOptionDivClick,
  onConfigurationOptionClick,
  archiveChat,
  direction,
  chatDescription,
  emitEvent,
  formatMessage,
  alternativeArchive,
}) {
  let chatEventActions;

  if (chat.elements && chat.elements.length > 0) {
    let eventActions = Object.values(window.Social.getChatEventsConfig()).map(
      (elem) => {
        return (
          <span
            className="message-box-option"
            key={elem.eventName}
            onClick={() => emitEvent(elem.eventName, chat)}
          >
            {elem.label}
          </span>
        );
      }
    );

    if (eventActions && eventActions.length > 0) {
      eventActions.unshift(
        <span className="title" key="item-description">
          {chatDescription}
        </span>
      );

      eventActions.push(
        <span className="separator" key="item-separator"></span>
      );

      chatEventActions = eventActions;
    }
  }

  return (
    <div
      className={`message-box-options-box ${direction}`}
      ref={setOptionBoxRef}
      onClick={onOptionDivClick}
    >
      <span className="title">{formatMessage({ id: "general.message" })}</span>

      <span className="message-box-option" onClick={onConfigurationOptionClick}>
        {formatMessage({ id: "chat.chatSettings" })}
      </span>

      <span className="separator"></span>

      {chatEventActions}

      {chat.archived ? (
        <span className="message-box-option">
          {formatMessage({ id: "chat.noOptionsAvailable" })}
        </span>
      ) : (
        <span className="message-box-option" onClick={archiveChat}>
          {alternativeArchive
            ? formatMessage(
                { id: alternativeArchive },
                { flag: chat.flags[0].flagName }
              )
            : formatMessage({ id: "chat.archiveMessage" })}
        </span>
      )}
    </div>
  );
}

class MessageBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOptionsOpen: false,
      optionBoxDirection: "bottom",
      generalMessageOptions: false,
      messages: [],
      archived: false,
      loading: false,
      loadingMore: false,
      page: 0,
      hasMorePages: false,
      waitingMessageSentConfirmation: false,
      newMessagesToScrollCount: 0,
      isLastMessageFromCurrentUser: false,
      canSendMessage: false,
      draft: this.props.chat.draft || {
        title: "",
        category: window.Social.getChatConfig().defaultCategory,
        privacy: window.Social.getChatConfig().defaultPrivacy,
        elements: [],
        recipients: {},
        message: "",
        flag: null,
      },
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    const { chat } = this.props;
    this.mounted = true;
    !chat.newChat && this.fetchData();
  }

  componentWillUnmount() {
    this.mounted = false;
    this.props.changeChat({
      chat: this.props.chat,
      draft: this.state.draft,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    let otherCollapsed = {};
    let canFetchData = false;
    if (
      this.props.chat &&
      !this.props.chat.collapsed &&
      prevProps.chat.collapsed
    ) {
      otherCollapsed = {
        messages: [],
        page: 0,
        hasMorePages: false,
      };
      canFetchData = true;
    }
    let otherMessages = {};
    if (
      this.props.newMessage &&
      this.props.newMessage.messageId &&
      this.props.newMessage.messageId !==
        (prevProps.newMessage && prevProps.newMessage.messageId)
    ) {
      if (
        this.state.waitingMessageSentConfirmation &&
        this.props.newMessage.from.username === this.props.currentUser.login
      ) {
        otherMessages.waitingMessageSentConfirmation = false;
      }
      otherMessages.draft = {
        ...this.state.draft,
        message: "",
      };
      otherMessages.messages = this.state.messages.concat(
        this.props.newMessage
      );
      otherMessages.isLastMessageFromCurrentUser =
        this.props.newMessage.from.username === this.props.currentUser.login;
    }
    if (
      Object.values(otherCollapsed).length > 0 ||
      Object.values(otherMessages).length > 0 ||
      prevState.canSendMessage !== this.canSendMessage()
    ) {
      this.setState(
        {
          ...otherCollapsed,
          ...otherMessages,
          canSendMessage: this.canSendMessage(),
        },
        () => canFetchData && this.fetchData()
      );
    }
  }

  canSendMessage() {
    let canSendMessage = false;
    if (this.props.chat.newChat) {
      if (
        this.state.draft.message.trim().length > 0 &&
        Object.values(this.state.draft.recipients).length > 0
      ) {
        canSendMessage = true;
      } else {
        canSendMessage = false;
      }
    } else {
      canSendMessage = true;
    }

    return canSendMessage;
  }

  setNewMessagesToScrollCount(add, count) {
    this.setState({
      newMessagesToScrollCount: add
        ? this.state.newMessagesToScrollCount + 1
        : count,
    });
  }

  fetchData(params = {}) {
    this.setState({
      loading: true,
    });

    ChatService.getChatMessages(this.props.id, params).then((res) => {
      res &&
        res.data &&
        res.data.content &&
        this.mounted &&
        this.setState({
          messages: res.data.content.reverse(),
          loading: false,
          hasMorePages: !res.data.last || false,
        });
    });
  }

  handleInfiniteOnLoad() {
    if (this.state.loadingMore) return;

    this.setState({
      loadingMore: true,
    });
    ChatService.getChatMessages(this.props.id, {
      page: this.state.page + 1,
    })
      .then((res) => {
        res &&
          res.data &&
          res.data.content &&
          this.setState({
            messages: res.data.content.reverse().concat(this.state.messages),
            loading: false,
            page: this.state.page + 1,
            hasMorePages: !res.data.last || false,
            loadingMore: false,
          });
      })
      .catch(() => {
        this.setState({
          loadingMore: false,
        });
      });
  }

  onMessageInputChange(state) {
    if (this.mounted) {
      this.setState({
        draft: {
          ...this.state.draft,
          message: state,
        },
      });
    }
  }

  close(e) {
    e.stopPropagation();
    this.props.closeChat(this.props.id);
  }

  getTitle() {
    const { formatMessage } = this.props.intl;
    const { chat, flags } = this.props;
    const chatConfig = window.Social.getChatConfig();
    let alternativeArchive;

    if (chatConfig.allowFlags && chat.flags && chat.flags.length === 1) {
      let currentFlag = flags.find((elem) => elem.id === chat.flags[0].id);
      if (currentFlag) {
        alternativeArchive = currentFlag.alternativeArchiveText;
      }
    }

    return (
      <div
        className={`message-box-header ${
          this.props.notifications[this.props.chat.id] ? "notify" : ""
        }`}
        onClick={this.onCardClick.bind(this)}
        disabled
      >
        <div className="message-box-header-content">
          <span className="message-box-title">
            {this.state.generalMessageOptions
              ? formatMessage({ id: "general.messageSettings" })
              : this.getTitleString()}
          </span>
          {this.props.chat.newChat ||
          this.state.generalMessageOptions ||
          this.props.chat.collapsed ? (
            false
          ) : (
            <span className="message-box-status">
              <ChatDescription
                chat={this.props.chat}
                flags={this.props.flags}
              />
            </span>
          )}
        </div>

        <div className="message-box-action-container">
          {/* { this.props.notifications[this.props.chat.id] && <span className="notification-badge"></span> } */}
          {!this.props.chat.newChat &&
            !this.state.generalMessageOptions &&
            !this.props.chat.collapsed && (
              <Icon
                className={`action-button ${
                  this.state.isOptionsOpen ? "active" : ""
                }`}
                onClick={this.toggleChatOptionsBox.bind(this)}
                component={MoreSvg}
              />
            )}

          <Icon
            className={`action-button`}
            onClick={this.close.bind(this)}
            component={CloseSvg}
          />

          {this.state.isOptionsOpen && (
            <ChatOptionsBox
              chat={this.props.chat}
              chatDescription={
                <ChatDescription
                  chat={this.props.chat}
                  flags={this.props.flags}
                />
              }
              setOptionBoxRef={this.setOptionBoxRef.bind(this)}
              onOptionDivClick={this.onOptionDivClick}
              onConfigurationOptionClick={this.onConfigurationOptionClick.bind(
                this
              )}
              archiveChat={this.archiveChat.bind(this)}
              emitEvent={this.emitEvent.bind(this)}
              direction={this.state.optionBoxDirection}
              formatMessage={formatMessage}
              alternativeArchive={alternativeArchive}
            />
          )}
        </div>
      </div>
    );
  }

  getTitleString() {
    const { chat, flags } = this.props;
    const { formatMessage } = this.props.intl;
    const currentFlag = flags.find(
      (elem) => elem.id === (chat.flags && chat.flags[0] && chat.flags[0].id)
    );
    const archivedPrefix =
      (currentFlag && currentFlag.alternativeArchivedPrefix) ||
      "chat.archivedPrefix";

    if (chat.newChat) {
      return formatMessage({ id: "chat.newChat" });
    } else if (chat.description) {
      return chat.archived
        ? `${formatMessage({ id: archivedPrefix })} ${chat.description}`
        : chat.description;
    }
    return formatMessage(
      { id: "chat.noDescriptionTitle" },
      {
        name: chat.createdBy.username,
        archived: chat.archived ? formatMessage({ id: archivedPrefix }) : "",
        number: chat.recipients.length - 1,
      }
    );
  }

  onCategoryChange({ privacy, category, elements = [] }) {
    privacy &&
      category &&
      this.setState({
        draft: {
          ...this.state.draft,
          category,
          elements,
          privacy,
        },
      });
  }

  onChatTitleChange(e) {
    this.setState({
      draft: {
        ...this.state.draft,
        title: e.target && e.target.value,
      },
    });
  }

  onSelectedUsersChange(users) {
    this.setState({
      draft: {
        ...this.state.draft,
        recipients: users,
      },
    });
  }

  onCardClick() {
    this.props.onCardClick(this.props.id);
  }

  onOptionDivClick(e) {
    e.stopPropagation();
  }

  onConfigurationOptionClick(e) {
    e.stopPropagation();
    this.setState(
      {
        generalMessageOptions: true,
        isOptionsOpen: false,
      },
      document.removeEventListener("click", this.handleClickOutside)
    );
  }

  archiveChat(e) {
    e.stopPropagation();

    ChatService.archiveChat(this.props.chat.id).then(this.props.getChatList);

    this.setState(
      {
        isOptionsOpen: false,
        archived: true,
      },
      document.removeEventListener("click", this.handleClickOutside)
    );

    this.props.updateChat({ id: this.props.chat.id, archived: true });
  }

  emitEvent = (eventName, chat) => {
    if (window.hasOwnProperty("Social")) {
      window.Social.emit(eventName, chat.elements);

      this.setState(
        {
          isOptionsOpen: false,
        },
        document.removeEventListener("click", this.handleClickOutside)
      );
    }
  };

  closeGeneralMessageOptions() {
    this.setState({
      generalMessageOptions: false,
    });
  }

  saveGeneralMessageOptions(params) {
    this.setState({
      generalMessageOptions: false,
    });
    this.props.updateChatName(this.props.chat.id, params.description);
    this.props.updateChat({
      id: this.props.chat.id,
      description: params.description,
    });
    ChatService.putChat(this.props.chat.id, params);
  }

  toggleChatOptionsBox(e) {
    e.stopPropagation();

    this.setState({
      isOptionsOpen: true,
      optionBoxDirection: this.props.chat.collapsed ? "top" : "bottom",
    });

    document.addEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.optionBoxRef && !this.optionBoxRef.contains(event.target)) {
      event.stopPropagation();

      this.setState(
        {
          isOptionsOpen: false,
        },
        document.removeEventListener("click", this.handleClickOutside)
      );
    }
  }

  setOptionBoxRef(node) {
    this.optionBoxRef = node;
  }

  sendMessage(message, mentions) {
    if (this.state.canSendMessage) {
      if (
        this.props.chat.newChat &&
        this.props.wsConnection &&
        this.props.wsConnection.send &&
        !this.state.waitingMessageSentConfirmation
      ) {
        this.setState({
          waitingMessageSentConfirmation: true,
        });
        this.props.handshakeNewChatCreated &&
          this.props.handshakeNewChatCreated();
        let recipients = Object.values(this.state.draft.recipients).map(
          (elem) => {
            return {
              user: {
                username: elem.username,
              },
            };
          }
        );
        let elements = this.state.draft.elements
          ? [].concat(this.state.draft.elements)
          : [];
        if (
          this.state.draft.privacy &&
          !(
            this.state.draft.category ===
              window.Social.getChatConfig().defaultCategory &&
            window.Social.getChatConfig().defaultCategoryPrivacyLock
          )
        ) {
          elements.push({
            description: window.Social.getChatConfig().privacyElement,
            content: this.state.draft.privacy,
          });
        }
        let flag = this.state.draft.flag ? [{ id: this.state.draft.flag }] : [];
        this.props.wsConnection.send(
          JSON.stringify({
            chat: {
              recipients: recipients,
              elements: elements,
              description: this.state.draft.title,
              flags: flag,
            },
            mentions: mentions || [],
            content: message,
          })
        );
      } else if (
        this.props.wsConnection &&
        this.props.wsConnection.send &&
        !this.state.waitingMessageSentConfirmation
      ) {
        this.props.wsConnection.send(
          JSON.stringify({
            chat: {
              id: this.props.chat.id,
              recipients: this.props.chat.recipients,
              elements: this.props.chat.elements,
              flags: this.props.chat.flags,
            },
            mentions: mentions || [],
            content: message,
          })
        );
        this.setState({
          draft: {
            ...this.state.draft,
          },
          waitingMessageSentConfirmation: true,
        });
      }
    }
  }

  setMessageListRef(node) {
    this.messageListRef = node;
  }

  scrollMessageListToBottom() {
    if (this.messageListRef) {
      this.messageListRef.scrollTop = this.messageListRef.scrollHeight;

      this.setNewMessagesToScrollCount(false, 0);
    }
  }

  onFlagSelect(value) {
    this.setState({
      draft: {
        ...this.state.draft,
        flag: value,
      },
    });
  }

  render() {
    const { collapsed } = this.props.chat;
    return (
      <div className="message-box">
        <Card title={this.getTitle()} className={collapsed ? "collapsed" : ""}>
          <MessageBoxContent
            id={this.props.id}
            chat={this.props.chat}
            draft={this.state.draft}
            flags={this.props.flags}
            messages={this.state.messages}
            collapsed={this.props.chat.collapsed}
            generalMessageOptions={this.state.generalMessageOptions}
            closeGeneralMessageOptions={this.closeGeneralMessageOptions.bind(
              this
            )}
            saveGeneralMessageOptions={this.saveGeneralMessageOptions.bind(
              this
            )}
            sendMessage={this.sendMessage.bind(this)}
            handleInfiniteOnLoad={this.handleInfiniteOnLoad.bind(this)}
            hasMorePages={this.state.hasMorePages}
            newMessage={this.props.newMessage}
            chatState={this.state.draft.message}
            waitingMessageSentConfirmation={
              this.state.waitingMessageSentConfirmation
            }
            newMessagesToScrollCount={this.state.newMessagesToScrollCount}
            setNewMessagesToScrollCount={this.setNewMessagesToScrollCount.bind(
              this
            )}
            setMessageListRef={this.setMessageListRef.bind(this)}
            scrollMessageListToBottom={this.scrollMessageListToBottom.bind(
              this
            )}
            isLastMessageFromCurrentUser={
              this.state.isLastMessageFromCurrentUser
            }
            loading={this.state.loading}
            loadingMore={this.state.loadingMore}
            dismissNotification={this.props.dismissNotification}
            canSendMessage={this.state.canSendMessage}
            profiles={this.props.profiles}
            onChatTitleChange={this.onChatTitleChange.bind(this)}
            onCategoryChange={this.onCategoryChange.bind(this)}
            onSelectedUsersChange={this.onSelectedUsersChange.bind(this)}
            onMessageInputChange={this.onMessageInputChange.bind(this)}
            onFlagSelect={this.onFlagSelect.bind(this)}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.Users.currentUser,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeChat: (params) => dispatch(changeChat(params)),
  updateChat: (chat) => dispatch(updateChat(chat)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MessageBox));
